import styled from '@emotion/styled';
import { COLORS } from '../../constants';

export const StyledNavigation = styled.div`
  width: 100%;
  background-color: ${COLORS.gray95};
`;
